module.exports = __webpack_public_path__ + "img/error.5b038bd5.png";